import ApiService from '@/services/ApiService'

const REPOSITORY_URL = 'usuario'

const UsuarioRepository = {
  login (codigoAcceso, pin, dominio) {
    let data = {
      codigo_acceso: codigoAcceso,
      pin: pin,
      dominio: dominio
    }
    return ApiService.post(`${REPOSITORY_URL}/login`, data)
  },

  loginToken (codigoAcceso, tokenTransferencias) {
    let data = {
      codigo_acceso: codigoAcceso,
      token_transferencias: tokenTransferencias
    }
    return ApiService.post(`${REPOSITORY_URL}/login_token`, data)
  },

  logout () {
    return ApiService.post(`${REPOSITORY_URL}/logout`)
  },

  cambiarPin (pinActual, pinNuevo) {
    let data = {
      pin_actual: pinActual,
      pin_nuevo: pinNuevo
    }
    return ApiService.post(`${REPOSITORY_URL}/cambiar_pin`, data)
  },

  cambiarCorreoElectronico (correoElectronico) {
    let data = {
      correo_electronico: correoElectronico
    }
    return ApiService.post(`${REPOSITORY_URL}/cambiar_correo_electronico`, data)
  },

  operadorRol (correoElectronico) {
    return ApiService.get(`${REPOSITORY_URL}/operador_rol`)
  },

  solicitarResetPin (codigoAcceso) {
    let data = {
      codigo_acceso: codigoAcceso
    }
    return ApiService.post(`${REPOSITORY_URL}/solicitar_reset_pin`, data)
  },

  resetPin (url, pinNuevo) {
    let data = {
      url: url,
      pin_nuevo: pinNuevo
    }
    return ApiService.post(`${REPOSITORY_URL}/reset_pin`, data)
  }
}

export default UsuarioRepository
